import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, SupportAgent } from "@mui/icons-material";
import MaskAndValid from "utils/maskAndValid";

export default function InfoDialog({ row, onClose }) {
  const details = [
    { label: "Origem", value: row?.OrigemFormat },
    { label: "Status Resolução", value: row?.ResolucaoFormat },
    { label: "Responsável Atual", value: row?.Nome },
    { label: "Status do Chamado", value: row?.Status },
    { label: "Departamento", value: row?.Canal },
    {
      label: "Data última Atualização",
      value: row.DataUltimaAtualizacaoFormat,
    },
    {
      label: "Data Criação",
      value: row.DataCriacaoFormat,
    },
    {
      label: "Assunto",
      value: row.Assunto,
    },
    {
      label: "CPF/CNPJ",
      value: MaskAndValid.maskCPNJCPF(row.Documento),
    },
  ];

  return (
    <Dialog open onClose={onClose} maxWidth={"md"} fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <SupportAgent style={{ marginRight: "12px" }} />
            Protocolo - {row.Protocolo}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <Grid container direction="column">
          <Grid item xs={12}>
            {details.map(({ label, value }) => (
              <Typography key={label} variant="caption">
                <strong>{label}:</strong> {value}
              </Typography>
            ))}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "1.5rem" }}
          onClick={onClose}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
